<template>
	<div>
		<header class="modal-header">
			<span></span>
			<span class="modal-title" role="heading" data-test="modal-title">
				Confirm Filter Selection
			</span>
			<font-awesome-icon
				:icon="['fal', 'times']"
				@click="handleCancelFilterSelection"
				role="button"
				aria-label="close"
				class="close"
			/>
		</header>
		<div class="modal-body">
			<p class="confirm-modal-text">
				The previously selected contacts will be deselected. Are you sure you
				want to proceed?
			</p>
			<OverviewModalFooter
				isSaveModal
				:primaryButtonName="'Confirm'"
				@handleClick="handleConfirmFilterSelection"
				@close="handleCancelFilterSelection"
			/>
		</div>
	</div>
</template>

<script>
import OverviewModalFooter from './OverviewModalFooter.vue';

export default {
	name: 'ConfirmFilterSelection',
	components: {
		OverviewModalFooter,
	},
	methods: {
		handleConfirmFilterSelection() {
			this.$emit('confirmFilterSelection');
		},
		handleCancelFilterSelection() {
			this.$emit('cancelFilterSelection');
		},
	},
};
</script>

<style lang="scss" scoped>
.modal-header {
	background: $white;
	color: $black;
	line-height: normal;
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-bottom: 1px solid $border-color-light;
	@include rem('padding', 18px 20px);
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;

	.close {
		@include rem('font-size', 22px);
		cursor: pointer;
		line-height: normal;
	}

	.modal-title {
		font-weight: 500;
		line-height: normal;
		@include rem('font-size', 18px);
	}
}
p.confirm-modal-text {
	padding: 20px;
	margin: 0;
}
</style>
